/**
 * Convert various YouTube URL formats to embed URL.
 * Supports:
 *   - https://www.youtube.com/watch?v=VIDEO_ID
 *   - https://youtu.be/VIDEO_ID
 *   - https://www.youtube.com/embed/VIDEO_ID (returned as-is)
 *   - https://www.youtube.com/shorts/VIDEO_ID
 *   - https://m.youtube.com/watch?v=VIDEO_ID
 */
export const toYouTubeEmbed = (url) => {
  if (!url) return '';
  try {
    let videoId = '';
    const u = new URL(url);
    const host = u.hostname.replace(/^www\.|^m\./, '');

    if (host === 'youtu.be') {
      videoId = u.pathname.slice(1).split('/')[0];
    } else if (host === 'youtube.com') {
      if (u.pathname.startsWith('/embed/')) {
        videoId = u.pathname.split('/')[2];
      } else if (u.pathname.startsWith('/shorts/')) {
        videoId = u.pathname.split('/')[2];
      } else if (u.pathname === '/watch') {
        videoId = u.searchParams.get('v') || '';
      }
    }

    if (!videoId) {
      // Try regex fallback
      const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
      if (m) videoId = m[1];
    }

    if (!videoId) return url; // return original if we can't parse
    return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
  } catch {
    // Fallback regex if URL parsing fails (e.g. missing protocol)
    const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}?rel=0&modestbranding=1`;
    return url;
  }
};
